/*  ========================================================================
    # Scripts - Mobile Menus
    ========================================================================  */

const MobileMenus = {
  cfg: {
    body: document.querySelector('body'),
    menuToggle: document.querySelector('.c-header__toggle'),
    header: document.querySelector('.c-header'),
    mobileSubmenuToggle: document.querySelectorAll('.c-header__mobile-nav-submenu-toggle'),
    footer: document.querySelector('.c-footer'),
    footerMenuToggle: document.querySelectorAll('.c-footer__menu-title'),
    states: {
      menuOpen: 'menu-open'
    }
  },

  /**
   * Handle menu toggle click
   */
  handleMenuToggle() {
    this.cfg.menuToggle.addEventListener('click', () => {
      this.cfg.body.style.overflow = this.cfg.body.style.overflow === 'hidden' ? 'auto' : 'hidden';
      this.cfg.header.classList.toggle(this.cfg.states.menuOpen);
    });
  },

  /**
   * Handle submenu toggle click
   */
  handleSubmenuToggle() {
    if (this.cfg.mobileSubmenuToggle.length === 0) {
      return;
    }

    this.cfg.mobileSubmenuToggle.forEach(element => {
      element.addEventListener('click', () => {
        const parent = element.closest(`.c-header__mobile-nav-item-wrapper`);
        parent.classList.toggle(this.cfg.states.menuOpen);
      });
    });
  },

  /**
   * Handle footer menu toggle click
   */
  handleFooterMenuToggle() {
    this.cfg.footerMenuToggle.forEach(element => {
      element.addEventListener('click', () => {
        const parent = element.closest(`.c-footer__menu`);
        parent.classList.toggle(this.cfg.states.menuOpen);
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.header) {
      this.handleMenuToggle();
      this.handleSubmenuToggle();
    }

    if (this.cfg.footer && this.cfg.footerMenuToggle.length > 0) {
      this.handleFooterMenuToggle();
    }
  }
};

export default MobileMenus;
